import { useState } from "react";
import Logo from "../../assets/Indian_Army.png";
import "../Login/login.css";
import "./certificate.css";
import axios from "axios";

const Certificate = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDownload = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/certificate",
        { email: email.trim() }
      );
      window.open(res.data.url, "_blank");
    } catch (err) {
      if (err.response?.status === 404) {
        setError("No certificate found for this email address");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left-section">
        <div className="login-logo-container">
          <img src={Logo} alt="Indian Army Logo" className="login-logo-image" />
          <h1 className="login-join-text">JOIN INDIAN ARMY</h1>
        </div>
      </div>
      <div className="login-right-section">
        <div className="login-content-wrapper">
          <div className="signin-container">
            <h2 className="login-title">Certificate Download</h2>
            <form className="signin-form" onSubmit={handleDownload}>
              <div className="cert-input-group">
                <label className="input-label">Registered Email Address</label>
                <input
                  type="email"
                  className="input-field"
                  placeholder="Enter your registered email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {error && <p className="cert-error">{error}</p>}
              <button
                type="submit"
                className="signin-button"
                disabled={loading}
              >
                {loading ? "Please wait..." : "Download Certificate"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
